export enum LayoutItemType {
    GROUP = 'Group',
    TILE = 'Tile',
}

export const DEFAULT_TILE_PADDING = 8;
export const DEFAULT_GROUP_PADDING = 8;
export const DEFAULT_GROUP_GUTTER = 8;
export const DEFAULT_LB_GUTTER = 16;

export const LIVEBOARD_STYLE_VARIABLES: Record<string, string | string[]> = {
    lbBgColor: '--ts-var-liveboard-layout-background',
    lbGutter: '--ts-var-liveboard-layout-gutter',
    headerBgColor: '--ts-var-liveboard-header-background',
    headerFontSize: '--ts-var-liveboard-header-font-size',
    headerFontColor: '--ts-var-liveboard-header-font-color',
    tileBgColor: '--ts-var-liveboard-tile-background',
    tilePadding: '--ts-var-liveboard-tile-padding',
    tileTitleFontColor: '--ts-var-viz-title-color',
    tileTitleFont: '--ts-var-viz-title-font-family',
    tileTitleFontSize: '--ts-var-liveboard-tile-title-fontsize',
    tileTitleFontWeight: '--ts-var-liveboard-tile-title-fontweight',
    tileDescriptionFontColor: '--ts-var-viz-description-color',
    borderRadius: '--ts-var-liveboard-tile-border-radius',
    tileBorderColor: '--ts-var-liveboard-tile-border-color',
    tileBoxShadow: '--ts-var-viz-box-shadow',
    tileTitleTextTransform: '--ts-var-viz-title-text-transform',
    tileDescriptionTextTransform: '--ts-var-viz-description-text-transform',
    tileTableHeaderBg: '--ts-var-liveboard-tile-table-header-background',
    groupBgColor: '--ts-var-liveboard-group-background',
    groupBorderColor: '--ts-var-liveboard-group-border-color',
    groupPadding: '--ts-var-liveboard-group-padding',
    groupTitleFontSize: '--ts-var-liveboard-group-title-font-size',
    groupTitleFontWeight: '--ts-var-liveboard-group-title-font-weight',
    groupTitleFontColor: '--ts-var-liveboard-group-title-font-color',
    groupDescriptionFontColor:
        '--ts-var-liveboard-group-description-font-color',
    groupTileBgColor: '--ts-var-liveboard-tile-background',
    groupTileBorderColor: '--ts-var-liveboard-tile-border-color',
    groupTileTitleFontColor: '--ts-var-liveboard-group-tile-title-font-color',
    groupTileDescriptionFontColor:
        '--ts-var-liveboard-group-tile-description-font-color',
    groupTileTitleFontSize: '--ts-var-liveboard-group-tile-title-font-size',
    groupTileTitleFontWeight: '--ts-var-liveboard-group-tile-title-font-weight',
    groupTilePadding: '--ts-var-liveboard-group-tile-padding',
    noteBodyFontColor: '--ts-var-liveboard-notetitle-body-font-color',
    noteHeadingFontColor: '--ts-var-liveboard-notetitle-heading-font-color',
    kpiNumberFontColor: '--ts-var-kpi-hero-color',
    // Used for the new KPI style override feature.
    // The above property `kpiNumberFontColor` may be deprecated in the future.
    kpiHeroFontColor: '--ts-var-kpi-hero-color',
    kpiComparisonFontColor: '--ts-var-kpi-comparison-color',
    kpiAnalyseFontColor: '--ts-var-kpi-analyze-text-color',
    axisDataLabelColor: '--ts-var-axis-data-label-color',
    axisTitleColor: '--ts-var-axis-title-color',
    filterChipBgColor: '--ts-var-liveboard-chip-background',
    filterChipTextColor: '--ts-var-liveboard-chip-color',
    filterChipHoverBgColor: '--ts-var-liveboard-chip--hover-background',
    filterChipHoverTextColor: '--ts-var-liveboard-chip--hover-color',
    filterChipActiveBgColor: '--ts-var-liveboard-chip--active-background',
    filterChipActiveTextColor: '--ts-var-liveboard-chip--active-color',
    tabActiveBorderColor: '--ts-var-liveboard-tab-active-border-color',
    tabHoverColor: '--ts-var-liveboard-tab-hover-color',
    legendHoverBackground: '--ts-var-viz-legend-hover-background',
    parameterChipBgColor: '--ts-var-parameter-chip-background',
    parameterChipTextColor: '--ts-var-parameter-chip-text-color',
    parameterChipHoverBgColor: '--ts-var-parameter-chip-hover-background',
    parameterChipHoverTextColor: '--ts-var-parameter-chip-hover-text-color',
    parameterChipActiveBgColor: '--ts-var-parameter-chip-active-background',
    parameterChipActiveTextColor: '--ts-var-parameter-chip-active-text-color',
    lbBgDotColor: '--ts-var-liveboard-layout-background-dot-color',
    headerActionButtonBgColor:
        '--ts-var-liveboard-header-action-button-background',
    headerActionButtonFontColor:
        '--ts-var-liveboard-header-action-button-font-color',
    headerActionButtonHoverColor:
        '--ts-var-liveboard-header-action-button-hover-color',
    headerActionButtonActiveColor:
        '--ts-var-liveboard-header-action-button-active-color',
    headerBadgeBgColor: '--ts-var-liveboard-header-badge-background',
    headerBadgeFontColor: '--ts-var-liveboard-header-badge-font-color',
    headerBadgeModifiedBgColor:
        '--ts-var-liveboard-header-badge-modified-background',
    headerBadgeHoverColor: '--ts-var-liveboard-header-badge-hover-color',
    headerBadgeActiveColor: '--ts-var-liveboard-header-badge-active-color',
    kpiDeltaBadgePositiveBgColor:
        '--ts-var-kpi-delta-badge-positive-background',
    kpiDeltaBadgePositiveFontColor: '--ts-var-kpi-delta-badge-positive-color',
    kpiDeltaBadgeNegativeBgColor:
        '--ts-var-kpi-delta-badge-negative-background',
    kpiDeltaBadgeNegativeFontColor: '--ts-var-kpi-delta-badge-negative-color',
    legendTextColor: '--ts-var-chart-legend-text-color',
};
